import httpManager from "@/app/shared/utils/httpManager";

class IvrReportSevice {
  baseUrl = "/reports";

  async download(report: number, form: { ivr: number | undefined; date: string[] }) {
    const startDate = `${form.date.at(0)} 00:00`;
    const endDate = `${form.date.at(1)} 23:59`;
    const url = `${this.baseUrl}/${report}/download/?ivr=${form.ivr}&start_date=${startDate}&end_date=${endDate}`;

    return await httpManager.post(url, {}, { blob: true });
  }
}

export const ivrReportService = new IvrReportSevice();
